import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { User } from '@/modules/user/models/User';

export class TeamInvite extends BaseEntityModel {
  public id: number;
  public teamId: number;
  public userId: number;
  public sentAt?: string;

  public user: Relationship<User | null>;

  constructor(model: Partial<TeamInvite> = {}) {
    super(model);

    this.id = model.id!;
    this.teamId = model.teamId!;
    this.userId = model.userId!;
    this.sentAt = model.sentAt;

    this.user = User.mapModelOrNull(model.user);
  }
}
